module.exports = __webpack_public_path__ + "52e5ffa9aa39b1eb0ee6aacdff9e7df8.svg";